import { setCalendarColorScheme } from '../actions/internalActions';
import { mutator } from 'satcheljs';
import { getStore } from '../store/store';

mutator(setCalendarColorScheme, actionMessage => {
    const { calendarId, colorScheme } = actionMessage;
    getStore().assignedCalendarColors.set(calendarId, colorScheme);
});
